import { render, staticRenderFns } from "./EditIncome.vue?vue&type=template&id=55481382&scoped=true"
import script from "./EditIncome.vue?vue&type=script&lang=js"
export * from "./EditIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55481382",
  null
  
)

export default component.exports